import memoize from 'lru-memoize'
import {
  createValidator, required, minLength, match,
} from 'utility/validation'

const ResetPasswordFullFormValidation = createValidator({
  password: [required, minLength(8)],
  password_confirm: [match('password')],
})
export default memoize(10)(ResetPasswordFullFormValidation)
